

@if (!customizableMode) {
    <p-card>
    <div class="padding15">
        <div class="module-title">
            <div class="module-title-label" >Allocation Report</div>
            <div (click)="showAllocationReport()" style="cursor:pointer"><img class="svg-arrow-right-circle" src="../../assets/images/arrow-right-circle-outline.svg"></div>
        </div>

        @if (!data) {
            <div class='loading-spinner'></div>
        }

        @if (data) {
            <div class="module-div-includes-charts">
                <div class="module-div-chart-wrap">
                    <p-chart type="doughnut" [data]="chartData" [options]="options" width="176px" height="176px"></p-chart>
                    <div class="module-chart-center" >
                        <div class="module-chart-center-number">{{data.totalPortfolios}}</div>
                        <div class="label">Portfolios</div>
                    </div>
                </div>
                <div class="allocation-module-details-panels">
                    <div>
                        <span class="allocation-module-details-panel">Out of Tolerance</span>
                        <img class="svg-arrow-right-circle" (click)="showAllocationReportWithOutOfTolerance()" src="../../assets/images/arrow-right-circle-outline.svg">
                        <div class="allocation-module-details-panel-color-number modules-panel-number" [style.color]="colors[0]">{{data.outOfToleranceCount}}</div>
                    </div>
                    <div>
                        <span class="allocation-module-details-panel">In Tolerance</span>
                        <img class="svg-arrow-right-circle" (click)="showAllocationReportWithInTolerance()" src="../../assets/images/arrow-right-circle-outline.svg">
                        <div class="allocation-module-details-panel-color-number modules-panel-number" [style.color]="colors[1]">{{data.inToleranceCount}}</div>
                    </div>
                </div>
            </div>
        }

    </div>
    </p-card>
}
@if (customizableMode) {
    <div style="display: flex;flex-direction: row;height: 100%;align-items: center;padding-bottom: 15px;">
        <div style="height:176px;width: 176px;margin-left: 10px;">
            <img src="../../assets/images/donut-skeleton.svg" style="cursor: inherit!important;">
        </div>
        <div style="margin-left: 30px;width:60%;">
            <div style="display: flex;flex-direction: row;">
                <div class="skeleton-styles-rectangle" style="width:65%;"></div>
                <div class="skeleton-styles-circle" style="margin-left: 10px;"></div>
            </div>
            <div class="skeleton-styles-rectangle" style="width:25%; margin-top: 5px;"></div>

            <div style="display: flex;flex-direction: row;margin-top: 10px;">
                <div class="skeleton-styles-rectangle" style="width:65%;"></div>
                <div class="skeleton-styles-circle" style="margin-left: 10px;"></div>
            </div>
            <div class="skeleton-styles-rectangle" style="width:25%;margin-top: 5px;"></div>
        </div>
    </div>
}

